export interface Value {
  rank: String,
  address: String,
  amount: String
}

export const initialState = {
  data: []
}

export interface StateType {
  data: Array<Value>
}

export interface ActionType {
  type: String,
  addData: Array<Value>
}

/**
 * 数字添加逗号
 */
export const addComma = (val: String) => {
  return (+val >= 1000 || +val <= -1000) ? (+val).toLocaleString() : val
}

export const reducer = (state: StateType, action: ActionType) => {
  let hData = action.addData.map((i, index) => {
    i.amount = Math.floor(+i.amount * 100) / 100 + ''
    i.rank = ((state.data.length + index) < 9 ? ('0' + (state.data.length + 1 + index)) : (state.data.length + 1 + index)) + '.'
    if (typeof (i.amount) === 'undefined' || i.amount === null || i.amount.trim() === '') {
      return {...i}
    } else {
      return {
        ...i,
        ...{
          amount: addComma(String(parseFloat((i.amount + ''))))
        }
      }
    }
  })
  switch (action.type) {
    case 'init':
      return {data: [...hData]}
    case 'add':
      return {data: [...state.data, ...hData]}
    default:
      throw new Error()
  }
}

export default reducer